import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=2f74eaf2&scoped=true&"
import script from "./Empresas.vue?vue&type=script&lang=js&"
export * from "./Empresas.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/site.css?vue&type=style&index=0&id=2f74eaf2&prod&scoped=true&lang=css&"
import style1 from "./Empresas.vue?vue&type=style&index=1&id=2f74eaf2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f74eaf2",
  null
  
)

export default component.exports